<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col">
                View Of Allocated Manpower
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-primary mx-1" [disabled]="isDisabled" *ngIf="this.common.PageRight.IsAdd"
                    (click)="onEditClick({AllocationType:'A',ESS_ShiftWiseManpowerMasterId:0})">
                    <i class="bi bi-person-add" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Addition':'Loading...'}}
                </button>

                <button type="button" class="btn btn-primary mx-1" [disabled]="isDisabled"
                    (click)="onEditClick({AllocationType:'R',ESS_ShiftWiseManpowerMasterId:0})" *ngIf="this.common.PageRight.IsAdd">
                    <i class="bi bi-person-dash" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Reduction':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
    <div class="card-body">
        <form (ngSubmit)="Validate(FilterForm)" #FilterForm="ngForm" name="FilterForm" novalidate>
            <div class="row py-1">
                <div class="col-md-3">
                    <label class="Label">Branch</label>
                    <ng-select [items]="Branchs" bindLabel="BranchName" bindValue="BranchMasterID"
                        placeholder="Select Branch" [(ngModel)]="Filter.BranchID" name="Branch"
                        (change)="ComboLoad('Client')">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select branch.
                    </div>
                </div>
                <div class="col-md-3">
                    <label class="Label">Client</label>
                    <ng-select [items]="Clients" bindLabel="ClientGroupName" bindValue="ClientGroupMasterID"
                        placeholder="Select Client" [(ngModel)]="Filter.ClientID" name="Client"
                        (change)="ComboLoad('Site')">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select client.
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="Label">Site</label>
                    <ng-select [items]="Sites" bindLabel="SiteName" bindValue="SiteMasterID" placeholder="Select Site"
                        [(ngModel)]="Filter.SiteID" name="Site">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select site.
                    </div>
                </div>
            </div>
            <div class="row py-1">
                <!-- <div class="col-md-3">
                    <label class="Label">Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="DD MMM YYYY" name="Date" [(ngModel)]="Filter.Date"
                            ngbDatepicker #Date="ngbDatepicker" readonly [disabled]="Filter.IsAllTransactions" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="Date.toggle()"
                            type="button"></button>
                    </div>
                </div>
                <div class="col-md-3 align-content-center">
                    <input mdbCheckbox class="form-check-input" name="IncludeAll" type="checkbox"
                        [(ngModel)]="Filter.IsAllTransactions" /><label class="ms-1">Include
                        All Transactions</label>
                </div> -->
                <div class="col"></div>
                <div class="col-auto align-content-center">
                    <button class="btn btn-primary mx-1" name="submit" *ngIf="this.common.PageRight.IsView">
                        <i class="bi bi-download" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Load':'Loading...'}}
                    </button>
                    <button type="button" class="btn btn-primary mx-1" name="refresh" (click)="Back()">
                        <i class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Back':'Loading...'}}
                    </button>
                </div>
            </div>
        </form>

        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th scope="col">#</th>
                    <th scope="col" style="width: 10px;">Entry No</th>
                    <th scope="col" style="width: 10px;">WONo</th>
                    <th scope="col">WODate</th>
                    <th scope="col">Client Name</th>
                    <th scope="col">Site Name</th>
                    <th scope="col" style="width: 50px;" width="50px">No Of Person</th>
                    <th scope="col" style="width: 50px;" width="50px" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let element of Manpowers; let i = index">
                    <th scope="row" [ngClass]="{'highlight-row': element.AllocationType === 'O'}">{{ i + 1 }}
                    </th>
                    <td style="width: 10px;" [ngClass]="{'highlight-row': element.AllocationType === 'O'}">{{
                        element['EntryNo'] }}
                    </td>
                    <td style="width: 10px;" [ngClass]="{'highlight-row': element.AllocationType === 'O'}">{{
                        element['WONo'] }}</td>
                    <td [ngClass]="{'highlight-row': element.AllocationType === 'O'}">{{ element['WODate'] }}</td>
                    <td [ngClass]="{'highlight-row': element.AllocationType === 'O'}">{{
                        element['ClientGroupName'] }}</td>
                    <td [ngClass]="{'highlight-row': element.AllocationType === 'O'}">{{ element['SiteName'] }}
                        <span class="ms-1" *ngIf="element.AllocationType === 'O'"
                            style="color: rgb(221, 119, 24);">(OP)</span> <span *ngIf="element.IsAutoReduction"
                            style="color:rgb(4, 178, 231)">(AUTO)</span>
                    </td>
                    <td style="width: 50px;" class="right-align" width="50px"
                        [ngClass]="{'highlight-row': element.AllocationType === 'O'}" class="text-end">
                        <div style="width: 65px;">
                            <span *ngIf="element.AllocationType === 'R'">-</span>
                            <span *ngIf="element.AllocationType === 'A' || element.AllocationType === 'O'">+</span>
                            <span class="no-of-person">{{ element.NoOfPerson }}</span>
                        </div>
                    </td>
                    <td style="width: 50px;" width="50px" [ngClass]="{'highlight-row': element.AllocationType === 'O','colHide': !this.common.PageRight.IsEdit}" class="text-center">
                        <button class="btn btn-sm btn-group-toggle" (click)="onEditClick(element)">
                            <i class="bi bi-pencil-square text-warning"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>